import type { WorkshopNavItem } from '../../workshop/workshopNavTypes';

/**
 * Entries of the Purchases "Reporting" menu, shared by the desktop top-nav dropdown
 * (OdooTopNav) and the mobile drawer (OdooShellMobileNav). Each item routes to
 * `/{resource}` inside the Purchases workspace, matching the Auto Workshop and Project
 * Management reports convention.
 */
export const PURCHASE_REPORTS_NAV: WorkshopNavItem[] = [
    { resource: 'purchaseRegisterReport', label: 'Purchase Register' },
];
